import React from "react";
import { Fragment } from "react";
import LoginBackground from "./LoginBackground";
import styles from "./Loginpage.module.css";
import { Outlet } from "react-router-dom";
import { calcBackgroundSize, getRandomInt } from "../../utils";
import { useEffect } from "react";

export default function WelcomePage() {
    var data = calcBackgroundSize();

    function randomGlow(width, height) {
        var x = getRandomInt(1, height); //selecting a random icon with row and coloumn
        var y = getRandomInt(1, width);
        var icon = document.querySelector(
            `.${styles.rows}:nth-child(${x}) i:nth-child(${y})`
        );
        icon.style.color = "rgba(0,255,149,1)";
        setTimeout(() => {
            icon.style.color = "#363636";
        }, 2000);
    }
    useEffect(() => {
        const glow = setInterval(
            randomGlow,
            1000,
            data.numIconsWidth,
            data.numIconsHeight
        );

        return () => {
            clearInterval(glow);
        };
    }, [data.numIconsHeight, data.numIconsWidth]);

    return (
        <Fragment>
            <div>
                <Fragment>
                    <LoginBackground />
                </Fragment>
                <link rel="stylesheet" href="css/style.css" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link
                    rel="preconnect"
                    href="https://fonts.gstatic.com"
                    crossOrigin
                />
                <link
                    href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@1,100&family=Tilt+Warp&display=swap"
                    rel="stylesheet"
                />
                <div className={styles.container}>
                    <div className={styles.login}>
                        <div className={styles.slideContainer}>
                            <h1 className={styles.logo}>
                                <span className={styles.wealth}>Wealth</span>
                                <span className={styles.watch}>
                                    <br></br>Watch.
                                </span>
                            </h1>
                        </div>
                        <div className={styles.loginContainer}>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
